var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2H8.5V9H7C6.44771 9 6 8.55229 6 8V3C6 2.44772 6.44772 2 7 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2V11C14 11.5523 13.5523 12 13 12H12.75V14.3895L13.0172 14.6595C13.1824 14.8265 13.4079 14.9199 13.6428 14.9187L14.206 14.9157C14.6922 14.9131 15.0869 15.3078 15.0843 15.794L15.0813 16.3572C15.0801 16.5921 15.1735 16.8176 15.3405 16.9828L15.7408 17.379C16.0864 17.7209 16.0864 18.2791 15.7408 18.621L15.3405 19.0172C15.1735 19.1824 15.0801 19.4079 15.0813 19.6428L15.0843 20.206C15.0869 20.6922 14.6922 21.0869 14.206 21.0843L13.6428 21.0813C13.4079 21.0801 13.1824 21.1735 13.0172 21.3405L12.621 21.7408C12.2791 22.0864 11.7209 22.0864 11.379 21.7408L10.9828 21.3405C10.8176 21.1735 10.5921 21.0801 10.3572 21.0813L9.79397 21.0843C9.30785 21.0869 8.91313 20.6922 8.91569 20.206L8.91865 19.6428C8.91989 19.4079 8.82648 19.1824 8.65951 19.0172L8.25916 18.621C7.91361 18.2791 7.91361 17.7209 8.25916 17.379L8.65951 16.9828C8.82648 16.8176 8.91989 16.5921 8.91865 16.3572L8.91569 15.794C8.91313 15.3078 9.30785 14.9131 9.79397 14.9157L10.3572 14.9187C10.5921 14.9199 10.8176 14.8265 10.9828 14.6595L11.25 14.3895V12H11C10.4477 12 10 11.5523 10 11V2H14ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9H15.5V2H17C17.5523 2 18 2.44772 18 3V8C18 8.55228 17.5523 9 17 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal3);
export default __webpack_public_path__ + "static/media/medal-3.62e5c56dcd1511cacf49cffd0ed7b0c9.svg";
export { ForwardRef as ReactComponent };